let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3IHI1")).then(() => parcelRequire('geWLV'));